import { createFileRoute } from "@tanstack/react-router";
import { infiniteQueryOptions } from "@tanstack/react-query";
import Index from "@/pages/Index";
import { getArticlesPage } from "@/services/unifiedNewsService";
import { FEED_PAGE_SIZE } from "@/context/NewsContext";
import { cdnImage, cdnWidthSet, shouldProxy } from "@/lib/images";

// Same options object NewsContext uses for the unfiltered feed, so the loader
// primes exactly the cache entry the page subscribes to.
const feedQueryOptions = infiniteQueryOptions({
  queryKey: ["articles", "feed", "", ""],
  initialPageParam: null as string | null,
  queryFn: ({ pageParam }) => getArticlesPage({ cursor: pageParam, limit: FEED_PAGE_SIZE, tags: [] }),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  staleTime: 60 * 1000,
});

const CARD_WIDTHS = [320, 420, 560, 700];
const CARD_SIZES = "(min-width: 1280px) 420px, (min-width: 768px) 45vw, calc(100vw - 2rem)";

export const Route = createFileRoute("/_app/")({
  loader: async ({ context }) => {
    try {
      const data = await context.queryClient.ensureInfiniteQueryData(feedQueryOptions);
      const first = data.pages[0]?.articles?.[0];
      return { leadImage: first?.imageUrl ?? null };
    } catch {
      return { leadImage: null };
    }
  },
  head: ({ loaderData }) => {
    const src = loaderData?.leadImage;
    if (!src || !shouldProxy(src)) return {};
    return {
      links: [
        {
          rel: "preload",
          as: "image",
          href: cdnImage(src, { width: 640, height: 340, quality: 60 }),
          imageSrcSet: cdnWidthSet(src, CARD_WIDTHS, { width: 640, height: 340, quality: 60 }),
          imageSizes: CARD_SIZES,
          fetchPriority: "high",
        },
      ],
    };
  },
  component: () => <Index />,
});
